export default "__VITE_ASSET__B9jekd46__"